import { style } from '@vanilla-extract/css';
import { themeVars } from '../themeVars.css';
import { nToPx } from '../00-functions';

export const rowClass = style({
  display: 'flex',
  flexDirection: 'row',
  gap: themeVars.space.x2,
});

export const rowCenterClass = style([
  rowClass,
  {
    alignItems: 'center',
  },
]);

export const rowEndClass = style([
  rowClass,
  {
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
]);

export const rowBetweenClass = style([
  rowClass,
  {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
]);

export const colClass = style({
  display: 'flex',
  flexDirection: 'column',
});

export const colCenterClass = style([
  colClass,
  {
    justifyContent: 'center',
    alignItems: 'center',
  },
]);

export const centeredContainerClass = style({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: nToPx(themeVars.space.x2, 0),
});
